/**
 * Created by pandemio on 2/7/19.
 */
import React from 'react';
import {Input, Col, Row, Alert, Button} from 'reactstrap';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from '../../custom-classes/api-calls';
import Checkbox from '@material-ui/core/Checkbox';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';


/**
 * Class to handle the address form group
 */
class FormCancellationSubscription extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            subscriptionId: props.subscriptionId ? props.subscriptionId : null,
            cancelAtPeriodEnd: props.cancelAtPeriodEnd ? props.cancelAtPeriodEnd : false,
            cancellationReason: props.cancellationReason ? props.cancellationReason : '',
            disabled: props.disabled ? props.disabled : null,
            showError: false,
            propsModal: {
                bodyText: '',
                visible: false
            },
            showModal: false,
            isEmployee: props.isEmployee ? props.isEmployee : false
        };
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.submitCancellation = this.submitCancellation.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    componentWillReceiveProps(props){
        this.setState({
            subscriptionId: props.subscriptionId ? props.subscriptionId : null,
            cancelAtPeriodEnd: props.cancelAtPeriodEnd ? props.cancelAtPeriodEnd : false,
            cancellationReason: props.cancellationReason ? props.cancellationReason : '',
            disabled: props.disabled ? props.disabled : null
        });
    }

    handleCheckChange() {
        this.setState({
            cancelAtPeriodEnd: !this.state.cancelAtPeriodEnd
        });
    }

    handleInput(e) {
        this.setState({
            cancellationReason: e.target.value
        });
    }

    toggleAlertModal() {
        this.setState({showModal: false});
    }

    submitCancellation() {
        let cancellationReason = String(this.state.cancellationReason).trim();
        if (cancellationReason.length === 0)
            this.setState({
                showError: true
            });
        else {
            // Activate the loading
            this.setState({
                loading: true
            }, ()=> {
                // This is promise
                let apiCall = ApiCalls.cancelSubscription(
                    this.state.subscriptionId,
                    !this.state.cancelAtPeriodEnd, // To cancel immediatly
                    this.state.cancellationReason,
                    true);

                // After the api call, fill the data
                apiCall.then((data)=> {
                    let messageToShow = '';
                    for (let i = 0; i < data.Messages.length; i++) {
                        messageToShow += data.Messages[i] + '<br/>';
                    }

                    let propsModal = {
                        bodyText: messageToShow,
                        visible: true
                    };

                    if (data.TransactionValid) {
                        this.setState({
                            propsModal: propsModal,
                            showModal: true,
                            loading: false,
                            disabled: true
                        }, ()=> {
                            // Update parent and send the plan Id
                            //this.props.updateParent(this.state);
                            //return this.state;
                        });
                    }
                    else
                        this.setState({
                            propsModal: propsModal,
                            showModal: true,
                            loading: false
                        });
                });
            });
        }
    }

    // Render the form group
    render() {
        return (
            <div>
                <Row>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <h2><Translate id="subscription-cancellation.title" options={{renderInnerHtml: true}}/></h2>
                    </Col>
                    <hr/>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <small>
                            <Translate id="subscription-cancellation.cancel-immediately-instructions"
                                       options={{renderInnerHtml: true}}/>
                        </small>
                    </Col>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Checkbox checked={this.state.cancelAtPeriodEnd}
                                  onChange={this.handleCheckChange}
                                  disabled={this.state.disabled}
                        />
                        <small>
                            <Translate id="subscription-cancellation.cancel-immediately"
                                       options={{renderInnerHtml: true}}/>
                        </small>
                    </Col>
                    <hr/>

                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <b><Translate id="subscription-cancellation.reasons" options={{renderInnerHtml: true}}/></b>
                        <br/>
                        <small>
                            <Translate id="subscription-cancellation.reasons-instructions"
                                       options={{renderInnerHtml: true}}/>
                        </small>
                    </Col>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Input type="textarea" defaultValue={this.state.cancellationReason}
                               disabled={this.state.disabled} onChange={this.handleInput}/>
                    </Col>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <small className="red-text">
                            <Alert color="warning">
                                <Translate id="subscription-cancellation.submit-note"
                                           options={{renderInnerHtml: true}}/>
                            </Alert>
                        </small>
                    </Col>
                    {
                        this.state.showError ?
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <Alert color="danger">
                                    <Translate id="subscription-cancellation.cancellation-required"
                                               options={{renderInnerHtml: true}}/>
                                </Alert>
                            </Col> : null

                    }
                    <Col sm={{size: 7, offset: 5}} md={{size: 7, offset: 5}} lg={{size: 7, offset: 5}}>
                        <Button disabled={this.state.disabled} color="warning" block onClick={this.submitCancellation}>
                            <Translate id="subscription-cancellation.submit" options={{renderInnerHtml: true}}/>
                        </Button>
                    </Col>
                </Row>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ? <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
            </div>
        )
    };
}

export default FormCancellationSubscription;